@if (showMockup) {
	<div
		class="intercom-mockup"
		[matTooltip]="'This is a mockup only for development'"
		matTooltipPosition="left"
	>
		<div class="intercom-bubble">
			<svg
				width="20"
				height="20"
				viewBox="0 0 32 32"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M25 3C26.6569 3 28 4.34315 28 6V26C28 27.6569 26.6569 29 25 29H7C5.34315 29 4 27.6569 4 26V6C4 4.34315 5.34315 3 7 3H25Z"
					fill="white"
				/>
				<path
					d="M21 22C21 20.8954 20.1046 20 19 20C17.8954 20 17 20.8954 17 22C17 23.1046 17.8954 24 19 24H21V22Z"
					fill="white"
				/>
				<path
					d="M15 22C15 20.8954 14.1046 20 13 20C11.8954 20 11 20.8954 11 22H15Z"
					fill="white"
				/>
				<path
					d="M15 14C16.6569 14 18 12.6569 18 11C18 9.34315 16.6569 8 15 8H7V11C7 12.6569 8.34315 14 10 14H15Z"
					fill="white"
				/>
				<path
					d="M20 11C20 12.6569 21.3431 14 23 14H25V11C25 9.34315 23.6569 8 22 8H20V11Z"
					fill="white"
				/>
			</svg>
		</div>
	</div>
}
